import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Li = styled.li`
  cursor: pointer;
  width: 100%;

  &:hover {
    background: ${themeGet('colors.black.10')};
    opacity: 0.5;
  }
`;

export const Link = styled.a`
  color: ${themeGet('colors.black.80')};

  &:hover,
  &:visited {
    color: ${themeGet('colors.black.80')};
  }
`;

export const Option = styled(Li)``;

export const SignOut = styled(Li)`
  border-top: 1px solid ${themeGet('colors.black.20')};
`;

// Menu rows are <li> > <a>/<button>; the padding lives on the link or button
// so the whole row stays clickable.
const menuAction = css`
  display: block;
  width: 100%;
  padding: 16px 20px;
  color: ${themeGet('colors.black.80')};

  &:focus-visible {
    outline: 2px solid ${themeGet('colors.primary.100')};
    outline-offset: -2px;
  }
`;

export const MenuLink = styled(Link)`
  ${menuAction}
`;

export const MenuButton = styled.button`
  ${menuAction}
  margin: 0;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
`;
